<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <kasa-hesap-plani-create-or-update v-model="plan"></kasa-hesap-plani-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="createNew"
                    :fields="fields"
                    pagination="server"
                    search
                    :buttons="buttons"></v-table>
    </b-card> 
</template>

<script>
import { BCard } from 'bootstrap-vue';
import NetsisOperationsApi from '@/api/netsis-operations';
import KasaHesapPlaniCreateOrUpdate from './components/KasaHesapPlaniCreateOrUpdate.vue';

export default{
    components:{
        BCard,
        KasaHesapPlaniCreateOrUpdate
    },
    data(){
        return {
            loading:false,
            editing:false,
            fields:[
                {thClass:'w-25 text-nowrap',name:'Borç/Alacak',key:'B_A'},
                {thClass:'w-25 text-nowrap',name:'Tip',key:'TypeName'},
                {thClass:'w-25 text-nowrap',name:'Kod',key:'Code'},
                {thClass:'w-25 text-nowrap',name:'Kasa Kodu',key:'VaultCode'},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            plan:{
                Id:null,
                Code: null,
                VaultCode: null,
                B_A: null,
                Type: null
            }
        }
    },
    methods:{
        provider(data){
            return NetsisOperationsApi.KasaHesapPlani.Table(data)
        },
        clearForm(){
            this.editing = false
            this.plan.Id = null
            this.plan.Code = null
            this.plan.VaultCode = null
            this.plan.B_A = null
            this.plan.Type = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.plan.Id = item.Id
            this.plan.Code = item.Code
            this.plan.VaultCode = item.VaultCode
            this.plan.B_A = item.B_A
            this.plan.Type = item.Type
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            NetsisOperationsApi.KasaHesapPlani.CreateOrUpdate(this.editing,this.plan).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem kasa hesap planını kaydı silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    NetsisOperationsApi.KasaHesapPlani.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>